import { MenuButton } from '@szhsin/react-menu';
import styled from 'styled-components';

export const StyledCreatAgentModal = styled.div`
  width: 100%;

  .flex-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;

    .description {
      display: none;
      position: absolute;
      left: 40%;
      padding: 5px;
      border-radius: 5px;
      border: 1px solid rgba(157, 157, 157, 0.2);
      background-color: var(--white);
    }

    &:hover {
      .description {
        display: block;
      }
    }

    &.tag-section {
      justify-content: space-between;

      .tag-text {
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        padding: 5px 10px;
        border-radius: 10px;
        border: 1px solid rgb(157, 157, 157);
        text-transform: capitalize;
      }
    }
  }

  .memory-wrap {
    margin-bottom: 20px;
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      margin-bottom: 20px;
    }

    .memory-enable {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 20px;
      width: 100%;
      background-color: transparent;
      border-radius: 16px;
      border: 1px solid rgba(157, 157, 157, 0.5);
      margin-bottom: 20px;

      .stick-wrap {
        width: 48px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(173, 176, 178, 0.15);
        border-radius: 50%;

        img {
          width: 24px;
          height: 24px;
          color: rgb(100, 116, 139);
        }
      }

      .enable-title {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 500;
        margin-bottom: 8px;
      }

      .enable-desc {
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        color: rgb(100, 116, 139);
      }
    }

    .btn-check {
      position: relative;
      width: 45px;
      height: 26px;
      cursor: pointer;
      border-radius: 50px;
      background: #ccc;

      &.checked {
        background: black;

        &::before {
          left: 21px;
        }
      }

      &::before {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 22px;
        height: 22px;
        transition: all ease-in-out 0.3s;
        border-radius: 50px;
        background: white;
      }
    }

    .memory {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
      padding: 14px 20px;
      background-color: var(--white);
      border-radius: 12px;
      border: 1px solid rgba(157, 157, 157, 0.3);
      margin-bottom: 10px;
      .memory-heading {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        margin-bottom: 10px;
        width: 100%;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        @media (min-width: 576px) {
          max-width: 600px;
        }
      }
      .memory-date {
        font-size: 14px;
        line-height: 18px;
        font-weight: 400;
      }
      .category-wrap {
        position: relative;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px;
        @media (min-width: 576px) {
          flex-wrap: nowrap;
        }
        .category {
          text-transform: capitalize;
          font-size: 14px;
          line-height: 18px;
          font-weight: 400;
          padding: 5px 10px;
          border-radius: 16px;
          border: 1px solid rgba(157, 157, 157, 0.3);
        }
      }

      .icon-wrap {
        display: flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
      }
    }
  }

  .memory-disable {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px;
    width: 100%;
    background-color: transparent;
    border-radius: 16px;
    border: 1px solid rgba(157, 157, 157, 0.5);

    .stick-wrap {
      width: 48px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 14px;
      background-color: rgba(173, 176, 178, 0.15);
      border-radius: 50%;

      img {
        width: 24px;
        height: 24px;
        color: rgb(100, 116, 139);
      }
    }

    .disable-title {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 500;
      margin-bottom: 8px;
    }

    .disable-desc {
      width: 100%;
      max-width: 400px;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      margin: 0 auto;
      color: rgb(100, 116, 139);
      text-align: center;
    }
  }

  .react-select__multi-value__label {
    .tag-text {
      display: none;
    }
  }

  .react-select__single-value {
    .flex-wrap > .description {
      display: none;
    }
  }

  .header {
    width: 100%;
    margin: 0 0 20px;
    padding: 0 0 15px;
    border-bottom: 1px solid #cdcdcd;

    .heading {
      display: block;
      font-size: 20px;
      line-height: 24px;
    }
  }

  .title {
    display: block;
    font-size: 18px;
    line-height: 24px;
    margin: 0 0 8px;
    color: var(--text-color);
  }

  .column-wrap {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0 0 10px;
    position: relative;

    @media (min-width: 576px) {
      flex-direction: row;
    }

    .column {
      width: 100%;
      flex-grow: 1;
      @media (min-width: 576px) {
        width: 49%;
      }
    }
  }

  .item-holder {
    width: 100%;
    margin: 0 0 20px;
    color: var(--light-gray);

    p {
      margin: 0 0 20px;
    }
  }

  .react-select__control {
    padding-left: 10px;
  }

  .web-search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    margin: 0 0 10px;

    .text-box {
      display: flex;
      align-items: center;
      gap: 6px;

      .icon {
        flex-shrink: 0;
        font-size: 20px;
        line-height: 1;
        color: var(--light-gray);
      }
      .text {
        display: block;
        color: var(--text-color);
      }
    }

    .btn {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 36px;
      border-radius: 10px;
      background: rgba(26, 42, 108, 0.1);
    }
  }

  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    padding-top: 15px;
    border-top: 1px solid #cdcdcd;
  }

  label {
    position: relative;
  }

  .btn-prompt {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 18px;
    line-height: 1;
    width: 28px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
      background: var(--gray-100);
    }
  }

  .btn-domain {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    line-height: 18px;
    line-height: 1;
    border-radius: 5px;
    padding: 5px;
    cursor: pointer;
    &:hover {
      background: var(--gray-100);
    }
  }
`;

export const MenuBtn = styled(MenuButton)`
  position: relative;
`;
